import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LeadManagementPropsState {
    [key: string]: string[];
}

const initialState: LeadManagementPropsState = {
    leadStates: [],
    leadSources: [],
    leadStages: [],
    leadStatuses: [],
    leadAdmissionStatuses: [],
    leadWelcomeCallByAdmissionTeamStatuses: [],
    leadVisaProcessingStatuses: [],
    leadApplicationMovedStatuses: [],
    leadConditionalOfferLetterStatuses: [],
    leadUnConditionalOfferLetterStatuses: [],
    leadFeePaymentStatuses: [],
    leadFileSubmissionStatuses: [],
    leadFollowUpStatuses: [],
    leadAssigneeOptions: [],
    leadSubAgentOptions: [],
    leadCampaignOptions: [],
    leadPrefferedStreams: [],
    leadSuperAgents:[],
    leadAdmissionSubStatus:[],
    leadSubSources:[],
    leadSubStages:[],
    leadSubStatuses: [],
    leadDestinations: [],
    preferredUniversities: [],
    nameSearchString: [],
    phoneSearchString: [],
    createdAtStartDate: [],
    createdAtEndDate: [],
    transferredAt: [],
    transferredEndAt: [],
    updatedAtStartDate: [],
    updatedAtEndDate: [],
    leadIntakeMonth: [],
    leadIntakeYear: [],
    departments:[],
    followUpAtStartDate: [],
    followUpAtEndDate: []


};

const leadManagementPropsSlice = createSlice({
    name: 'leadManagementProps',
    initialState,
    reducers: {
        setLeadProperty: (state, action: PayloadAction<{ key: string; value: string[] }>) => {
            if (state.hasOwnProperty(action.payload.key)) {
                state[action.payload.key] = action.payload.value;
            }
        },

        setSearchString: (state, action: PayloadAction<{ key: string; value: string[] }>) => {
            if (state.hasOwnProperty(action.payload.key)) {
                state[action.payload.key] = action.payload.value;
            }
        },
        
        setDateFilters: (state, action: PayloadAction<{ startDate?: string[]; endDate?: string[] }>) => {
            if (action.payload.startDate !== undefined) {
                state.createdAtStartDate = action.payload.startDate;
            }
            if (action.payload.endDate !== undefined) {
                state.createdAtEndDate = action.payload.endDate;
            }
        },

        setUpdatedAtDateFilters: (state, action: PayloadAction<{ startDate?: string[]; endDate?: string[] }>) => {
            if (action.payload.startDate !== undefined) {
                state.updatedAtStartDate = action.payload.startDate;
            }
            if (action.payload.endDate !== undefined) {
                state.updatedAtEndDate = action.payload.endDate;
            }
        },

        // clear all lead management props
        clearLeadManagementProps: () => initialState,

        // clear lead management props other than the nameSearchString and phoneSearchString
        clearLeadManagementFilterProps: (state) => {
            state.leadStates = [];
            state.leadSources = [];
            state.leadStages = [];
            state.leadStatuses = [];
            state.leadAdmissionStatuses = [];
            state.leadWelcomeCallByAdmissionTeamStatuses = [];
            state.leadVisaProcessingStatuses = [];
            state.leadApplicationMovedStatuses = [];
            state.leadConditionalOfferLetterStatuses = [];
            state.leadUnConditionalOfferLetterStatuses = [];
            state.leadFeePaymentStatuses = [];
            state.leadFileSubmissionStatuses = [];
            state.leadFollowUpStatuses = [];
            state.leadAssigneeOptions = [];
            state.leadSubAgentOptions = [];
            state.leadCampaignOptions = [];
            state.leadPrefferedStreams = [];
            state.leadSuperAgents = [];
            state.leadAdmissionSubStatus = [];
            state.leadSubSources = [];
            state.leadSubStages = [];
            state.leadSubStatuses = [];
            state.leadDestinations = [];
            state.preferredUniversities = [];
            state.createdAtStartDate = [];
            state.createdAtEndDate = [];
            state.transferredAt = [];
            state.transferredEndAt = [];
            state.updatedAtStartDate = [];
            state.updatedAtEndDate = [];
            state.leadIntakeMonth = [];
            state.leadIntakeYear = [];
            state.departments = [];
            state.followUpAtStartDate = [];
            state.followUpAtEndDate = [];
        },

        // clear lead management props nameSearchString and phoneSearchString
        clearLeadManagementPropsSearchString: (state) => {
            state.nameSearchString = [];
            state.phoneSearchString = [];
        },

        clearLeadManagementAssigneeOptions: (state) => {
            state.leadAssigneeOptions = [];
        }
    }
});

export const { setLeadProperty,
    setSearchString,
    setDateFilters,
    setUpdatedAtDateFilters,
    clearLeadManagementProps,
    clearLeadManagementFilterProps,
    clearLeadManagementPropsSearchString,
    clearLeadManagementAssigneeOptions } = leadManagementPropsSlice.actions;
export default leadManagementPropsSlice.reducer;
